export default __webpack_public_path__ + "static/media/213.3b0c4d0b.jpg";